export const GENRE_HIERARCHY = {
  "Rap / Hip-Hop": [
    "Horrorcore",
    "Trap Metal",
    "Phonk",
    "Emo Rap",
    "Dark Trap",
    "Cloud Rap",
    "Boom Bap",
    "US Drill",
    "UK Drill",
    "Grime",
    "Gangsta Rap",
    "Conscious Hip-Hop",
    "Lo-fi Hip-Hop",
    "Memphis Rap",
    "Experimental Hip-Hop"
  ],
  
  "R&B / Soul": [
    "Alternative R&B",
    "Dark R&B",
    "Trap Soul",
    "Neo-Soul",
    "Contemporary R&B",
    "Quiet Storm"
  ],
  
  "Pop": [
    "Hyperpop",
    "Dark Pop",
    "Lo-fi Pop",
    "Indie Pop",
    "Synth Pop",
    "Electro Pop",
    "Dream Pop",
    "Art Pop",
    "Alternative Pop",
    "Bedroom Pop"
  ],
  
  "Rock": [
    "Grunge",
    "Industrial Rock",
    "Post-Punk",
    "Alternative Rock",
    "Indie Rock",
    "Shoegaze",
    "Noise Rock",
    "Psychedelic Rock"
  ],
  
  "Goth / Darkwave": [
    "Goth Rock",
    "Darkwave",
    "Ethereal Wave",
    "Deathrock",
    "Coldwave",
    "Post-Punk Revival"
  ],
  
  "Metal": [
    "Black Metal",
    "Death Metal",
    "Deathcore",
    "Thrash Metal",
    "Doom Metal",
    "Stoner Metal",
    "Metalcore",
    "Nu-Metal",
    "Grindcore",
    "Progressive Metal",
    "Sludge Metal"
  ],
  
  "Electronic": [
    "Witch House",
    "Dark Ambient",
    "Drone",
    "Breakcore",
    "IDM",
    "Techno",
    "House",
    "Dubstep",
    "Drum & Bass",
    "Synthwave",
    "Vaporwave"
  ],
  
  "Punk / Hardcore": [
    "Punk",
    "Pop Punk",
    "Hardcore Punk",
    "Folk Punk",
    "Ska Punk",
    "Post-Hardcore",
    "Crust Punk"
  ],
  
  "Country / Folk": [
    "Alt-Country",
    "Folk",
    "Americana",
    "Outlaw Country",
    "Bluegrass"
  ],
  
  "World / Reggae": [
    "Reggae",
    "Dancehall",
    "Afrobeats",
    "Latin",
    "Cumbia"
  ]
};

// Flatten all subgenres into a single array for easy validation
export const ALL_SUBGENRES = Object.values(GENRE_HIERARCHY).flat();

// Get parent genre for a given subgenre
export const getParentGenre = (subgenre) => {
  for (const [parent, subgenres] of Object.entries(GENRE_HIERARCHY)) {
    if (subgenres.includes(subgenre)) {
      return parent;
    }
  }
  return null;
};
